import Mentions from 'antd/lib/mentions'

import 'antd/lib/mentions/style'

export * from 'antd/lib/mentions'

export default Mentions
